// extracted by mini-css-extract-plugin
module.exports = {"resultExplanationList":"styles_resultExplanationList__GvEhs"};